export default __webpack_public_path__ + "static/testimonialOvalTop-db37aebf9550bc4ebe3acebfd9db9a72.png";